'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'atom-simple';
var width = 448;
var height = 512;
var aliases = ["atom-alt"];
var unicode = 'f5d3';
var svgPathData = 'M148.6 453.3c19.3-6.4 39.8-15.7 60.6-27.7-28.7-18.8-57.5-42.1-84.9-69.5S73.7 300 54.9 271.3C43 292.1 33.7 312.5 27.2 331.9 9.7 384.4 14.4 423.9 35.5 445s60.5 25.8 113.1 8.3zm75.9-36.9c29.8-18.8 60.1-42.8 88.8-71.6s52.8-59 71.6-88.8c-18.8-29.8-42.8-60.1-71.6-88.8s-59-52.8-88.8-71.6c-29.8 18.8-60.1 42.8-88.8 71.6s-52.8 59-71.6 88.8c18.8 29.8 42.8 60.1 71.6 88.8s59 52.8 88.8 71.6zm0 18.8c-82.1 49.2-161.1 60.3-200.3 21.1S-3.9 338.1 45.3 256C-3.9 173.9-15 94.9 24.2 55.7S142.4 27.6 224.5 76.8c82.1-49.2 161.1-60.3 200.3-21.1S452.9 173.9 403.7 256c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1zM394.1 271.3c-18.8 28.7-42.1 57.5-69.5 84.9s-56.2 50.7-84.9 69.5c20.8 11.9 41.2 21.2 60.6 27.7 52.6 17.5 92.1 12.8 113.1-8.3s25.8-60.5 8.3-113.1c-6.4-19.3-15.7-39.8-27.7-60.6zm0-30.6c11.9-20.8 21.2-41.2 27.7-60.6 17.5-52.6 12.8-92.1-8.3-113.1s-60.5-25.8-113.1-8.3c-19.3 6.4-39.8 15.7-60.6 27.7 28.7 18.8 57.5 42.1 84.9 69.5s50.7 56.2 69.5 84.9zM209.2 86.4C188.4 74.5 168 65.2 148.6 58.7 96.1 41.2 56.6 45.9 35.5 67S9.7 127.6 27.2 180.1c6.4 19.3 15.7 39.8 27.7 60.6 18.8-28.7 42.1-57.5 69.5-84.9s56.2-50.7 84.9-69.5zM169.9 256c4.1-4.1 18.5-18.5 43.3-43.3l11.3-11.3c4.1 4.1 18.5 18.5 43.3 43.3L279.1 256c-4.1 4.1-18.5 18.5-43.3 43.3l-11.3 11.3c-4.1-4.1-18.5-18.5-43.3-43.3L169.9 256zm65.9 20.7L256.5 256c-17.3-17.3-25-25-32-32l-32 32c17.3 17.3 25 25 32 32l11.3-11.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAtomSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;